import React from 'react';
import svgHelper from './svgHelper';

const SvgIcon = ({icon = "", fill = false}) => {

    return (
        // <IconToRender className = {`mainStroke ${fill == true ? 'fill' : ''}`}/>
        svgHelper[icon]
    )    
}

export default SvgIcon;